<app-shell>
  @if (translationsLoaded()) {
    @if (isOutlet) {
      <router-outlet></router-outlet>
    }
  } @else {
    <div class="app-loading">
      <div class="loading-spinner"></div>
      <div class="loading-text">Loading...</div>
    </div>
  }
</app-shell>
